import * as z from "zod/v4";
import {
  createOrderEditInputSchema,
  createOrderEditOutputSchema,
} from "./base";

/**
 * Schema for updating order contact information (email and phone)
 */

const ContactInfoSchema_ = z.object({
  email: z.string().optional(),
  phone: z.string().optional(),
});

export const ContactInfoSchema: z.ZodType<ContactInfo> = ContactInfoSchema_;
export interface ContactInfo extends z.infer<typeof ContactInfoSchema_> {}

// Data schema for contact info update
const UpdateContactInfoData_ = z.object({
  email: z.string().optional().describe("New email address for the customer"),
  phone: z.string().optional().describe("New phone number for the customer"),
});

export const UpdateContactInfoDataSchema: z.ZodType<UpdateContactInfoData> =
  UpdateContactInfoData_;
export interface UpdateContactInfoData
  extends z.infer<typeof UpdateContactInfoData_> {}

// Full input schema
const UpdateContactInfoInput_ = createOrderEditInputSchema(
  UpdateContactInfoDataSchema,
);

export const UpdateContactInfoInput: z.ZodType<UpdateContactInfoInput> =
  UpdateContactInfoInput_;
export interface UpdateContactInfoInput
  extends z.infer<typeof UpdateContactInfoInput_> {}

// Output data schema
const UpdateContactInfoOutputData_ = ContactInfoSchema;

export const UpdateContactInfoOutputDataSchema: z.ZodType<UpdateContactInfoOutputData> =
  UpdateContactInfoOutputData_;
export interface UpdateContactInfoOutputData
  extends z.infer<typeof UpdateContactInfoOutputData_> {}

// Full output schema
const UpdateContactInfoOutput_ = createOrderEditOutputSchema(
  UpdateContactInfoOutputDataSchema,
);

export const UpdateContactInfoOutput: z.ZodType<UpdateContactInfoOutput> =
  UpdateContactInfoOutput_;
export interface UpdateContactInfoOutput
  extends z.infer<typeof UpdateContactInfoOutput_> {}
